import React from 'react';
import ReactDOM from 'react-dom/client';
import Router from './router';
import '../stylesheets/styles.css';
import QuestionnairePage from "@/pages/public/QuestionnairePage.jsx";

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Router />
        {/*<QuestionnairePage/>*/}
    </React.StrictMode>
);
